import React from 'react';
//scss
import './HomeButton.scss';
//animeJs
import anime from 'animejs';
//react-redux
import { connect } from 'react-redux';
//icon
import Mail from '../Icons/mail';
import Github from '../Icons/github';
import LinkedIn from '../Icons/linkedin';

class HomeButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Hover: false,
      position: document.documentElement.clientWidth,
    };
  }

  componentDidMount() {
    anime({
      targets: '.homeButton',
      translateX: 50,
      easing: 'linear',
      duration: 1000,
    });
    window.addEventListener('resize', this.listenToScroll);
  }

  listenToScroll = () => {
    const width = document.documentElement.clientWidth;
    this.setState({
      position: width,
    });
  };

  onHoverOn = e => {
    this.setState({
      Hover: !this.state.Hover,
    });
  };

  onHoverOut = e => {
    this.setState({
      Hover: !this.state.Hover,
    });
  };

  render() {
    return (
      <div
        className="homeButton"
        onMouseEnter={e => this.onHoverOn(e)}
        onMouseLeave={e => this.onHoverOut(e)}
      >
        <div className="homeButton_text">
          <div
            className="homeButton_text_initial"
            style={{
              width:
                this.state.Hover && this.state.position > 600
                  ? '21rem'
                  : this.state.position < 600
                  ? '4rem'
                  : '2.5rem',
              height:
                this.state.position <= 600 && this.state.Hover
                  ? '21rem'
                  : this.state.position > 600
                  ? '7rem'
                  : '2.5rem',
              color: this.state.Hover ? '#5fbda1' : '#7370a3',
            }}
          >
            {this.state.Hover ? 'Thompson' : 'T'}
          </div>
          <div
            className="homeButton_text_initial"
            style={{
              width:
                this.state.Hover && this.state.position > 600
                  ? '15rem'
                  : this.state.position < 600
                  ? '4rem'
                  : '2.5rem',
              height:
                this.state.position <= 600 && this.state.Hover
                  ? '15rem'
                  : this.state.position > 600
                  ? '7rem'
                  : '2.5rem',
              color: this.state.Hover ? '#5fbda1' : '#7370a3',
            }}
          >
            {this.state.Hover ? ' Harris' : 'H'}
          </div>
          {!this.props.slideMenu ? (
            <a
              href="mailto:william.thompson.harris@gmail.com?Subject=Hi!"
              target="_top"
            >
              <Mail />
            </a>
          ) : null}
          {!this.props.slideMenu ? (
            <a href="https://github.com/ThompsonHarris" target="_blank">
              <Github />
            </a>
          ) : null}
          {!this.props.slideMenu ? (
            <a
              href="https://www.linkedin.com/in/thompson-harris-97a528189/"
              target="_blank"
            >
              <LinkedIn />
            </a>
          ) : null}
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  slideMenu: state.nav.menuSlide,
});

export default connect(mapStateToProps)(HomeButton);
